<template>
    <div>
        <form method="POST"  id="form_booking_details" :action="prop_url_page_cart_add">
            <input type="hidden" name="_token" :value="csrf">
            <input type="hidden" :value="prop_route_id" name="route_id">
            <input type="hidden" :value="prop_operator_id" name="operator_id">
            <input type="hidden" :value="prop_schedule_id" name="schedule_id">
            <div class="formloader" id="formloader" v-bind:class="{ 'd-none': !loading }">
                <div class="loader">
                    <svg class="spinner" viewBox="0 0 50 50">
                        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>

            <div class="form-box single-content-widget p-0">
                    <div class="form-title-wrap d-flex flex-row justify-content-between align-items-center">
                        <img :src="prop_operator_image_url" style="max-width:110px" :alt="'LOGO:' + prop_operator_name">
                        {{ prop_route_name }}
                        <h3 class="title">{{ prop_route_type }}</h3>
                    </div>
                    <div class="form-content">

                        <div class="row mb-3">
                            <div class="col-lg-6">
                                <p><strong>{{ lang('departure_date') }}:</strong> {{ prop_schedule_departure_date }}</p>
                            </div>
                            <div class="col-lg-6">
                                <p><strong>{{ lang('departure_time') }}:</strong> {{ prop_schedule_departure_time }}</p>
                            </div>
                        </div>l

                        <div class="row mb-3">
                            <div class="col-lg-6">
                                <p><strong>{{ lang('arrival_date') }}:</strong> {{ prop_schedule_arrival_date }}</p>
                            </div>
                            <div class="col-lg-6">
                                <p><strong>{{ lang('arrival_time') }}:</strong> {{ prop_schedule_arrival_time }}</p>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-6">
                                <label class="label-text">{{ lang('no_of_people') }}</label>
                                <div class="qtyBtn2 d-flex align-items-center py-2 number_of_drivers" @click="numberOfDriversHandleClick">
                                    <div class="qtyDec2">
                                        <em class="la la-minus"></em>
                                    </div>
                                    <input type="text" name="number_of_drivers" :value="drivers_number" readonly>
                                    <div class="qtyInc2">
                                        <em class="la la-plus"></em>
                                    </div> <em class="la la-male font-size-24 ml-3"></em>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="qty-box">
                                    <label class="label-text">{{ lang('BookingDetailVehicle') }}</label>
                                    <div class="select-contain d-flex align-items-center">
                                        <select class="select-contain-select" name="vehicle" @change="changeSelectedVehicle()" v-model="selectedVehicle">
                                            <optgroup :label=" vehicle.name" v-for="(vehicle, data_index) in this.prop_all_vehicle_type.data">
                                                <option v-if="vehicle.vehicle_lengths.data.length !== 0"
                                                        :value="vehicle.id +'-'+ vehicle_length.id"
                                                        v-for="(vehicle_length, data_index) in vehicle.vehicle_lengths.data">
                                                    {{ lang(vehicle.name) }} {{ lang('up_to') }} {{ vehicle_length.max }} {{ lang('meters') }}
                                                </option>
                                                <option v-if="vehicle.vehicle_lengths.data.length === 0"
                                                        :value="vehicle.id"
                                                        :selected="prop_vehicle_id === vehicle.id">
                                                    {{ lang(vehicle.name) }}
                                                </option>
                                            </optgroup>
                                        </select>
                                        <div class="select-icon">
                                            <em class="la la-shuttle-van font-size-24"></em>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3">

                            <div class="col-lg-6 mb-3" v-if="showLoadedEmpty == 1">
                                <div class="qty-box">
                                    <label class="label-text">{{ lang('Loaded') }}</label>
                                    <div class="select-contain d-flex align-items-center">
                                        <select class="select-contain-select" name="loaded" @change="refreshData()" v-model="loaded">
                                            <option value="0">{{ lang('no') }}</option>
                                            <option value="1">{{ lang('yes') }}</option>
                                        </select>
                                        <div class="select-icon">
                                            <em class="la la-balance-scale font-size-24"></em>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 mb-3" v-if="loaded == 1">
                                <div class="qty-box">
                                    <label class="label-text">{{ lang('weight_kg')}}</label>
                                    <div class="select-contain d-flex align-items-center">
                                        <input class="form-control" type="text"
                                               name="weight"
                                               required>
                                        <div class="select-icon">
                                            <em class="la la-weight font-size-24"></em>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 mb-3" v-for="(servicePrice, data_index) in this.prop_route_other_services_prices.data">
                                <div class="qty-box">
                                    <label class="label-text">{{ lang(servicePrice.service.data.name) }}</label>
                                    <div class="select-contain d-flex align-items-center">
                                        <select :id="'service_'+servicePrice.service.data.id" class="select-contain-select" :name="'services[service_' + servicePrice.id +']'" @change="refreshData()">
                                            <option value="">{{ lang('no') }}</option>
                                            <option :value="servicePrice.id">{{ lang('yes') }}</option>
                                        </select>
                                        <div class="select-icon">
                                            <em class="la la-exclamation-circle font-size-24"></em>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 mb-3" v-if="showTemperature">
                                <div class="qty-box">
                                    <label class="label-text">{{ lang('temperature')}}</label>
                                    <div class="select-contain d-flex align-items-center">
                                        <input class="form-control" type="text"
                                               name="temperature"
                                               required>
                                        <div class="select-icon">
                                            <em class="la la-thermometer font-size-24"></em>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
            </div>

            <div class="form-box single-content-widget p-0" v-if="errorShow === false && infoShow === false" >
                <div class="form-content">
                    <div class="row m-0 mb-2">
                        <div class="col-lg-6 p-0 pr-1">
                            <div class="">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex flex-row">
                                            <p class="py-3 pl-3 text-black font-size-20 line-height-18 mr-3">{{ lang('price') }}</p>
                                            <p class="py-3 text-black font-size-20 line-height-18 font-weight-black">{{ prop_currency_symbol }} {{ (total === null || total == 0) ? '?' : total }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 p-0 pl-1">
                            <div class="">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex flex-row justify-content-lg-end">
                                            <p class="py-3 pl-3 text-black font-size-20 line-height-18 mr-3">{{ lang('vat') }}</p>
                                            <p class="py-3 text-black font-size-20 line-height-18 font-weight-black">{{ prop_currency_symbol }} {{ (total == 0 && vatPrice == 0) ? '?' : vatPrice }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-0">
                        <div class="col-lg-6 p-0">
                            <div class="px-3 py-2 d-flex align-items-center h-100 border-top border-green">
                                <p class="text-black font-size-20 line-height-18">
                                    <strong>{{ lang('grand_total') }}</strong> <span class="font-size-20" v-html="lang('including__all_fees')"></span>
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-6 p-0">
                            <div class="p-3 border-top border-green">
                                <div class="">
                                    <p class="py-2 font-size-30 text-right font-weight-black text-black">{{ prop_currency_symbol }} {{ (totalGross === null || totalGross == 0) ? '?' : totalGross }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-box single-content-widget p-0" v-if="errorShow === false && infoShow === false">
                <div class="form-content ">
                    <div class="contact-form-action">
                        <div class="input-box">
                            <label class="label-text d-flex justify-content-between align-items-center">
                                <span><strong>{{ lang('vehicle_registration_unit_id')}}</strong> <small>({{ lang('for_all_vehicles')}})</small></span>
                                <img src="images/vehicles.png" alt="" title="" class="ml-3" />
                            </label>
                            <div class="form-group">
                                <span class="la la-car-side form-icon" style="z-index: 1;"></span>
                                <div class="autocomplete">
                                    <input class="form-control" type="text"
                                           name="vehicle_registration_id"
                                           v-model="vehicleRegistrationId"
                                           @focus="startSearchTo($event)"
                                           @keyup="searchFilter($event)"
                                           @input="enforceInputRestrictions"                                           autocomplete="off"
                                           required>
                                    <div  class="autocomplete-result-list" v-if="this.userSavedVehiclesFiltered.length !== 0">
                                        <div class="result" v-for="(data_obj, data_index) in this.userSavedVehiclesFiltered"
                                             @click="setSavedVehicle(data_obj.vehicle_registration_id )">
                                            {{ data_obj.vehicle_registration_id }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="input-box" id="TrailerID" v-bind:class="{ 'd-none': !hasTrailer }">
                            <label class="label-text d-flex justify-content-between align-items-center">
                                <span><strong>{{ lang('if_accompanied_accompanying_trailer_id') }}</strong> <small>({{ lang('optional') }})</small></span>
                                <img src="images/trailer.png" alt="" title="" class="h-24 ml-3" />
                            </label>
                            <div class="form-group">
                                <span class="la la-car-side form-icon"></span>
                                <input class="form-control" type="text" name="vehicle_trailer_registration_id" value="" @keyup="changeTrailerIdText($event)" @change="changeTrailerIdText($event)">
                            </div>
                        </div>
                        <div class="input-box" id="CustomerRef">
                            <label class="label-text d-flex justify-content-between align-items-center">
                                <span><strong>{{ lang('customer_ref') }}</strong> <small>({{ lang('optional') }})</small></span>
                            </label>
                            <div class="form-group">
                                <span class="la la-link form-icon"></span>
                                <input class="form-control" type="text" name="customer_ref" value="">
                            </div>
                        </div>

                        <div class="btn-box d-flex justify-content-lg-end" v-if="selectableVehicles.length > 0">
                            <div class="input-group mb-3">
                                <span class="input-group-text" id="basic-addon3">{{ lang('use_previous_vehicle') }}</span>
                                <select v-model="vehicleRegistrationId" @change="setSavedVehicle(vehicleRegistrationId)" class="form-control theme-btn theme-btn-gray theme-btn-small">
                                    <option value="">{{lang('saved_vehicles')}} ({{selectableVehicles.length}})</option>
                                    <option v-for="vehicle in selectableVehicles" :key="vehicle.id" :value="vehicle.id">{{ vehicle.label }}</option>
                                </select>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="errorShow === false && infoShow === false">
                <div class="col-12 d-flex justify-content-center">
                    <button type="submit" class="theme-btn px-5 py-1">{{ lang('add_to_cart')}}</button>
                </div>
            </div>

            <div class="form-box single-content-widget p-0" v-if="errorShow">
                <div class="form-content" style="color: red">
                    {{ lang('error') }}: {{ errorText }}
                </div>
            </div>

            <div class="form-box single-content-widget p-0" v-if="infoShow">
                <div class="form-content" style="color: #6495ED">
                    {{ lang('info') }}: {{ infoText }}
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                showLoadedEmpty: false,
                loading: false,
                total: null,
                vatPrice: null,
                totalGross: null,
                form: null,
                drivers_number: this.prop_drivers_number,
                errorShow: false,
                errorText: '',
                infoShow: false,
                infoText: '',
                vehicleRegistrationId: '',
                userSavedVehiclesFiltered: [],
                hasTrailer: null,
                selectedVehicle: this.prop_vehicle_id + '-' +this.prop_vehicle_length_id,
                loaded: 0,
                selectableVehicles: []
            }
        },

        props: {
            prop_route_type: {
                required: true,
                type: String
            },
            prop_route_name: {
                required: true,
                type: String
            },
            prop_operator_name: {
                required: true,
                type: String
            },
            prop_operator_image_url: {
                required: true,
                type: String
            },
            prop_url_page_cart_add: {
                required: true,
                type: String
            },
            prop_route_id: {
                required: true,
                type: Number
            },
            prop_operator_id: {
                required: true,
                type: Number
            },
            prop_schedule_id: {
                required: true,
                type: Number
            },
            prop_vehicle_id: {
                required: true,
                type: Number
            },
            prop_vehicle_length_id: {
                required: true,
                type: Number
            },
            prop_schedule_departure_date: {
                required: true,
                type: String
            },
            prop_schedule_departure_time: {
                required: true,
                type: String
            },
            prop_schedule_arrival_date: {
                required: true,
                type: String
            },
            prop_schedule_arrival_time: {
                required: true,
                type: String
            },
            prop_drivers_number: {
                required: true,
                type: Number
            },
            prop_url_page_booking_details_calculation: {
                required: true,
                type: String
            },
            prop_total: {
                required: true,
                type: Number | null
            },
            prop_vat_price: {
                required: true,
                type: Number
            },
            prop_total_gross: {
                required: true,
                type: Number | null
            },
            prop_currency_symbol: {
                required: true,
                type: String
            },
            prop_all_vehicle_type: {
                required: true,
                type: Object
            },
            prop_route_other_services_prices: {
                required: true,
                type: Object
            },
            prop_user_saved_vehicles: {
                required: true,
                type: Array
            },
            prop_last_vehicle_registration_id: {
                required: true,
                type: String
            },
            prop_lang: {
                required: true,
                type: Object
            },
            prop_loaded_empty: {
                required: true,
                type: Number
            },
            prop_temperature: {
                required: true,
                type: Number
            },
        },
        computed: {
            showTemperature(){
                this.loading;
                if(document.getElementById('service_7') && document.getElementById('service_7').length && document.getElementById('service_7').value != '' && this.prop_temperature){
                    console.log('ja');
                    return true;
                }
                console.log('no');
                return false;
            }
        },
        mounted() {
            this.total = this.prop_total;
            this.vatPrice = this.prop_vat_price;
            this.totalGross = this.prop_total_gross;
            this.selectableVehicles = this.prop_user_saved_vehicles.map(vehicle => ({
                id: vehicle.vehicle_registration_id,
                label: vehicle.vehicle_registration_id
            }));
            this.showLoadedEmpty = this.prop_loaded_empty;
            this.hasTrailer = this.getVehicle(this.prop_vehicle_id).has_trailer === 1
        },

        methods:{
            lang(key){
                if (this.prop_lang.hasOwnProperty(key)){
                    return this.prop_lang[key];
                } else {
                    return 'invalid_key: ' + key;
                }
            },

            getVehicle(vehicleId){
                return this.prop_all_vehicle_type.data.filter(c => c.id == vehicleId)[0];
            },

            setSavedVehicle(vehicle_registration_id){
                this.vehicleRegistrationId = this.transformToAllowedFormat(vehicle_registration_id);
                this.userSavedVehiclesFiltered = [];
            },

            startSearchTo(){
                this.userSavedVehiclesFiltered = this.prop_user_saved_vehicles;
            },

            searchFilter(event){
                let text = event.target.value;

                this.vehicleRegistrationId = this.transformToAllowedFormat(text);

                this.userSavedVehiclesFiltered = this.prop_user_saved_vehicles.filter(c => c.vehicle_registration_id.toLowerCase().indexOf(text) > -1);
            },

            changeTrailerIdText(event){
                event.target.value = this.transformToAllowedFormat(event.target.value);
            },

            transformToAllowedFormat(text){
                // Transform to uppercase
                text = text.toUpperCase();

                // Remove special characters and spaces
                text = text.replace(/[^A-Z0-9]/g, '');

                return text;
            },

            enforceInputRestrictions(event) {
                const regex = /^[A-Z0-9]*$/;
                let input = event.target.value;

                // Convert to uppercase and remove invalid characters
                input = input.toUpperCase().replace(/[^A-Z0-9]/g, '');

                this.vehicleRegistrationId = input;
            },

            numberOfDriversHandleClick(e) {
                let _self = this;

                if (e.target.matches('.number_of_drivers .qtyDec2, .number_of_drivers .qtyDec2 *')) {
                    this.drivers_number = this.drivers_number - 1 ;
                    if (this.drivers_number < 1){
                        this.drivers_number = 1;
                    }

                    setTimeout(() => {
                        _self.calculateBookingFetch();
                    }, 200)
                }

                if (e.target.matches('.number_of_drivers .qtyInc2, .number_of_drivers .qtyInc2 *')) {
                    this.drivers_number = this.drivers_number + 1 ;
                    if (this.drivers_number > 3){
                        this.drivers_number = 3;
                    }

                    setTimeout(() => {
                        _self.calculateBookingFetch();
                    }, 200)
                }
            },

            calculateBookingFetch(){
                let _self = this;
                let url = this.prop_url_page_booking_details_calculation;
                let headers = {
                  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                  'Accept': 'application/json'
                };


                let form = $('#form_booking_details').serialize();

                _self.loading = true;
                _self.errorShow = false;
                _self.infoShow = false;

                axios.post(url + '?' + form, {
                    headers: headers
                }).then(response => {
                    if(response.data.error){
                        _self.errorShow = true;
                        _self.errorText = response.data.message;
                        return;
                    }

                    if(response.data.info){
                        _self.infoShow = true;
                        _self.infoText = response.data.message;
                        return;
                    }

                    _self.total = response.data.total === null ? null : parseFloat(response.data.total).toFixed(2);
                    _self.vatPrice = response.data.vat.price === null ? null : parseFloat(response.data.vat.price).toFixed(2);
                    _self.totalGross = response.data.total_gross === null ? null : parseFloat(response.data.total_gross).toFixed(2);
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    _self.loading = false;
                });
            },

            changeSelectedVehicle(){
                let value = this.selectedVehicle.toString();
                value = value.split("-")[0];

                this.hasTrailer = this.getVehicle(value).has_trailer === 1;
                this.refreshData();
            },

            refreshData(){
                this.calculateBookingFetch();
            }
        }
    }
</script>
